import { memberStorage } from 'utils';

import {
  changeSubscription,
  selectMember,
  selectSubscription,
  selectSubscriptions,
} from 'logic/member';

import { selectProduct } from 'logic/signup';

export const App = {
  template: `
    <div class="{{ $ctrl.theme.base }} {{ $ctrl.theme.slug }}"
      ng-switch="$ctrl.theme.navType">
      <div class="sticky-top">
        <div ng-switch-when="main">
          <nav-main
            avatar-src="$ctrl.member.profile.avatarUrl.thumb"
            items="$ctrl.theme.navMain"
            product="$ctrl.product"
            subscriptions="$ctrl.subscriptions"
            subscription="$ctrl.subscription"
            on-click-subscription="$ctrl.changeSubscription(subscription)">
          </nav-main>
          <nav-children
            items="$ctrl.theme.navChildren"
            ng-if="$ctrl.theme.navChildren.length">
          </nav-children>
        </div>
        <nav-plain ng-switch-when="plain">
        </nav-plain>
      </div>
      <ui-view></ui-view>
      <footer-main></footer-main>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState({ member, router, signup, theme }) {
        const voomeProductId =
          router.currentParams.voomeProductId ||
          memberStorage.get().voomeProductId;

        return {
          theme,
          member: selectMember(member),
          product: selectProduct(signup, voomeProductId),
          subscription: selectSubscription(member, voomeProductId),
          subscriptions: selectSubscriptions(member),
        };
      },

      mapDispatch() {
        return {
          changeSubscription,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/App.js